// The attention set of a pull request, worked out by the engine from what
// GitHub and the changelist server sent.
import { eng } from '../../diff/engine';
import type { AttentionMember } from '../../engine/types';
import { botsIn, reviewerLogin, threadLike, threadSummaries, toTimelineEvents } from '../../logic/timeline';
import type { PrState } from '../optimistic';

/** Who the pull request waits on, given `server`; null when it holds no pull request. `truncated`: older timeline items were dropped. */
export async function attentionOf(server: PrState, truncated: boolean): Promise<AttentionMember[] | null> {
  const { pr, timeline, threads, overrides } = server;
  if (!pr) return null;
  const author = pr.author?.login ?? 'ghost';
  const events = toTimelineEvents(timeline, { author, createdAt: pr.createdAt });
  const requested = pr.reviewRequests.nodes.map((n) => reviewerLogin(n.requestedReviewer)).filter((x): x is string => !!x);
  const result = await eng.attention({
    author,
    draft: pr.isDraft,
    state: pr.state,
    requested,
    events,
    threads: threadSummaries(threads.map(threadLike)),
    overrides: overrides.map((o) => ({ login: o.login, state: o.state, basis: o.basis, setAt: o.set_at })),
    bots: botsIn(timeline, [pr.author]),
    truncated,
  });
  return result.members;
}
